import { gql } from '@apollo/client';

export const DIVIDENDS_TO_WALLET = gql`
  mutation collectDividend($input: CollectDto) {
    collectDividend(collectDto: $input)
  }
`;
